/**
 * Feature flags for gradual UI rollout.
 * Set `enabled: true` when a feature is ready for production.
 */
export const FEATURE_FLAGS = {
  patientSubmissions: {
    enabled: false,
    description: "Subject questionnaire submissions card on Subject Edit",
  },
  patientQuestionnaireOnBehalf: {
    enabled: true,
    description: "Answer questionnaires on behalf of subject from schedule cards",
  },
};

export function isFeatureEnabled(featureKey) {
  return Boolean(FEATURE_FLAGS[featureKey]?.enabled);
}
